import at from 'lodash/at';
import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import type CSVHeaderColumn from '../../types/CSVHeaderColumn';
import type CSVRow from '../../types/CSVRow';

export default function filterCSV(
  headers: CSVHeaderColumn[],
  rows: CSVRow[],
  removeEmptyData: boolean,
) {
  if (!removeEmptyData) {
    return {
      headers,
      rows,
    };
  }

  const grouped = groupBy(headers, 'hasData');
  const indexes = map(grouped.true, 'index');

  return {
    headers: grouped.true,
    rows: rows.map((row) => at(row, indexes)),
  };
}
